export default __webpack_public_path__ + "static/media/logo_white.bdc7abcd.png";